import React from 'react';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook } from '@fortawesome/free-solid-svg-icons';

import NCCERLogo from "./../Assets/logos/NCCER";
import ATSSALogo from "./../Assets/logos/ATSSA logo white";
import IACETLogo from "./../Assets/logos/IACET_logo white";
import NYCBLogo from "./../Assets/logos/NYC_buildings logo white";
import OSHALogo from "./../Assets/logos/osha logo white";
import MWBELogo from "./../Assets/logos/MWBE logo white";
import linkInfo from '../data/navBarData';

const Footer = () => (
  <div className="footerContainer">
    <div className="footerTop">
      <div className="footerTopWrap">
        <div className="footerLinksContainer">
          <ul className="footerLinksWrap">
            {linkInfo.map(({id, name, link, index}) => (
              <li className="footerLink" key={`footer${name}${index}`}>
                <NavLink exact to={link}><p className="footerLinkText">{name}</p></NavLink>
              </li>
            ))}
          </ul>
        </div>
        <div className="footerSocialContainer">
          <a href="https://www.facebook.com/EssentialSafetyCom/">
            <i className="footerSocialLink fab fa-facebook-square"></i>
          </a>
          <a href="https://www.linkedin.com/in/kimsha-diaz-6a13911b/">
            {/* <FontAwesomeIcon icon={faFacebook} className="footerSocialLink fab fa-linkedin" /> */}
          </a>
        </div>
      </div>
    </div>
    <div className="footerMid">
      <div className="footerMidWrap">
        <div className="footerMidSquare">
          <OSHALogo alt="OSHA logo" />
        </div>
        <div className="footerMidSquare">
          <NYCBLogo alt="DOB Authorized Course Provider logo" />
        </div>
        <div className="footerMidSquare">
          <IACETLogo alt="IACET logo" />
        </div>
        <div className="footerMidSquare">
          <ATSSALogo alt="ATSSA logo" />
        </div>
        <div className="footerMidSquare">
          <NCCERLogo alt="NCCER logo"/>
        </div>
        <div className="footerMidSquare">
          <MWBELogo alt="MWBE logo"/>
        </div>
      </div>
    </div>
    <div className="footerLower">
      <p className="footerLowerText">©copyrights 2020. Essential Safety Communication, Inc.</p>
      <NavLink exact to="policies" className="footerPoliciesLink"><p >Policies</p></NavLink>
    </div>
  </div>
)

export default Footer;